import crypto from 'crypto-js'

export function hash(value: string) {
  return crypto.SHA256(value).toString(crypto.enc.Hex)
}
